import { apiSlice } from "./apiSlice";
import { setCollabRoom } from "../slice/chatSlice";

export const chatApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    createChatMessageWithFiles: builder.mutation({
      query: data => ({ body: data, method: "POST", url: "/api_chat/chat_message_with_files/" }),
    }),
    getCollabRoomData: builder.query({
      query: ({ id }) => `/api_chat/chat_room/${id}/custom_retrieve_private/`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setCollabRoom(result.data))).catch(error => {});
      },
    }),
    getPOCollabRoomData: builder.query({
      query: ({ id, type }) => `/api_chat/chat_room/${id}/${type}/custom_retrieve/`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setCollabRoom(result.data))).catch(error => {});
      },
    }),
  }),
});

export const {
  useCreateChatMessageWithFilesMutation,
  useGetPOCollabRoomDataQuery,
  useLazyGetCollabRoomDataQuery,
} = chatApiSlice;
